import { TablePage, Dialog } from 'web-mojo';
import { VendingTransaction, VendingTransactionList } from '@portal/models/VendingTransaction.js';
import './TransactionView.js';

export default class VendingTransactionsPage extends TablePage {
    constructor(options = {}) {
        super({
            title: 'Transactions',
            icon: 'bi-credit-card',
            pageName: 'vending_transactions',
            route: 'group/vending/transactions',
            permissions: ['view_payments', 'manage_payments', 'payments', 'manage_group', 'manage_groups'],
            requiresGroup: true,

            Collection: VendingTransactionList,

            defaultQuery: {
                sort: '-created',
                group: () => app.activeGroup?.id,
            },

            columns: [
                {
                    label: 'Date',
                    key: 'created',
                    formatter: 'relative',
                    sortable: true,
                },
                {
                    label: 'Terminal',
                    key: 'machine.name',
                    formatter: "default('—')",
                },
                {
                    label: 'Amount',
                    key: 'amount',
                    formatter: 'currency',
                    sortable: true,
                },
                {
                    label: 'Status',
                    key: 'status',
                    formatter: "badge:captured=success,refunded=secondary,failed=danger,reversed=warning",
                    filter: {
                        type: 'select',
                        options: [
                            { label: 'Captured', value: 'captured' },
                            { label: 'Refunded', value: 'refunded' },
                            { label: 'Failed',   value: 'failed' },
                            { label: 'Reversed', value: 'reversed' },
                        ]
                    },
                },
                {
                    label: 'Unlock',
                    key: 'metadata.unlock_status',
                    formatter: "badge:sent=success,no_device=warning,device_offline=danger",
                    visibility: 'lg',
                },
            ],

            viewDialogOptions: {
                header: false,
                size: 'md',
                footer: false,
            },

            selectable: false,
            searchable: false,
            sortable: true,
            filterable: true,
            paginated: true,
            showRefresh: true,
            showAdd: false,
            showExport: false,

            tableOptions: {
                striped: false,
                bordered: false,
                hover: true,
                responsive: true,
            },

            contextMenu: [
                { label: 'View Details', icon: 'bi bi-eye', action: 'view' },
                { label: 'Refund',       icon: 'bi bi-arrow-counterclockwise', action: 'refund-transaction', className: 'text-danger' },
            ],

            tableViewOptions: {
                hideActivePillNames: ['group'],
            },

            ...options,
        });
    }

    async onActionRefundTransaction(event, el) {
        const id = el.getAttribute('data-id');
        const txn = this.collection.get(id);
        if (!txn) return;

        if (txn.get('status') !== 'captured') {
            app.toast.warning('Only captured transactions can be refunded');
            return;
        }

        const amount = txn.amountFormatted();
        const confirmed = await Dialog.confirm({
            title: 'Refund Transaction',
            message: `Refund ${amount}? This will reverse the payment and restore inventory.`,
            confirmText: 'Refund',
            confirmClass: 'btn-danger',
        });
        if (!confirmed) return;

        const response = await txn.save({ refund: true });
        if (!response.success || !response.data.status) {
            app.toast.error(response.data?.error || 'Refund failed');
            return;
        }
        app.toast.success('Refund processed');
        this.collection.fetch();
    }
}
